import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const saveContacts = async (token, data) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/email`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export {
  saveContacts
}
